import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';

//configs
import { getUploadedFileURL } from '../../library/config';

//assets
import defaultAvatar from '../../assets/img/faces/face-0.jpg';


class UserProfileLogo extends Component {

    render() {
        const { userStore } = this.props;
        const width = this.props.width || "30px";
        const height = this.props.height || "30px";
        const borderRadius = this.props.borderRadius || "50px";
        let imageId = this.props.image_id || this.props.image_id === false ?
            this.props.image_id : userStore.currentUser.image;
        imageId = !isNaN(imageId) ? parseInt(imageId) : null
        const custom_className = this.props.className || ''
        return (

            <img
                src={imageId ? getUploadedFileURL(imageId) : defaultAvatar}
                alt="userImg"
                className={`img-fluid ${custom_className}`}
                style={{
                    width,
                    height,
                    borderRadius
                }}
            />
        )
    }
}

export default inject('commonStore', 'userStore')(applicationRouter(withLocalization(observer(UserProfileLogo))));